import type { RestrictedLock } from '@bms/common';

/**
 * Whether the site has a lock the Access Control page shows: an active lock
 * that is not a guest-room door (those are operated from the room dialog).
 * A hotel without one has nothing on that page, so its sidebar entry hides
 * (audit UX-17) and its door events live in Activity's Doors filter.
 */
export function hasSharedAreaLock(locks: readonly Pick<RestrictedLock, 'status' | 'lockCategory'>[]): boolean {
  return locks.some((lock) => lock.status === 'active' && lock.lockCategory !== 'guest_room');
}

/** The Activity page opened on its Doors filter. */
export const ACTIVITY_DOORS_PATH = '/activity?filter=doors';
